module.exports = "<p>chartc works!</p>\n\n"